export const GET_ONTHISDAY = 'app/Onthisday/GET_ONTHISDAY';
